var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFindPro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1.5C7.30109 1.5 7.11032 1.57902 6.96967 1.71967C6.82902 1.86032 6.75 2.05109 6.75 2.25V3H15.75V2.25C15.75 2.05109 15.671 1.86032 15.5303 1.71967C15.3897 1.57902 15.1989 1.5 15 1.5H7.5ZM17.25 3V2.25C17.25 1.65326 17.0129 1.08097 16.591 0.65901C16.169 0.237053 15.5967 0 15 0H7.5C6.90326 0 6.33097 0.237053 5.90901 0.65901C5.48705 1.08097 5.25 1.65326 5.25 2.25V3H3C1.34315 3 0 4.34315 0 6V16.5C0 18.1569 1.34315 19.5 3 19.5H19.5C21.1569 19.5 22.5 18.1569 22.5 16.5V6C22.5 4.34315 21.1569 3 19.5 3H17.25ZM3 4.5C2.17157 4.5 1.5 5.17157 1.5 6V8.25H21V6C21 5.17157 20.3284 4.5 19.5 4.5H3ZM21 9.75H15V10.125C15 10.4234 14.8815 10.7095 14.6705 10.9205C14.4595 11.1315 14.1734 11.25 13.875 11.25H8.625C8.32663 11.25 8.04048 11.1315 7.8295 10.9205C7.61853 10.7095 7.5 10.4234 7.5 10.125V9.75H1.5V16.5C1.5 17.3284 2.17157 18 3 18H19.5C20.3284 18 21 17.3284 21 16.5V9.75Z",
    fill: "#E2F7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindPro);
export default __webpack_public_path__ + "static/media/find_pro.6e6bbced3bdcbff4122f9f5d0e853087.svg";
export { ForwardRef as ReactComponent };